module.exports = __webpack_public_path__ + "img/complete.4f5212e8.png";